import { Button, InfoBadge, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";

export const PaddleBillingPaymentSuccessPage: React.FC = () => {
  const navigation = useNavigation();

  return (
    <InfoPage
      variant="success"
      title="You are now all set."
      description="Download Shapr3D and start modeling."
      primaryCTA={<Button onClick={() => navigation.goToDownloadPage()}>Download Shapr3D</Button>}
      footer={
        <InfoBadge
          standalone={true}
          description="Already have Shapr3D installed?"
          cta={
            <Button
              variant="grayscale"
              onClick={() => navigation.goToShaprApp({ autoOpen: false })}
            >
              Open Shapr3D
            </Button>
          }
        />
      }
    />
  );
};
